import React, { useState, useEffect } from 'react';
import { FaMapMarkerAlt, FaPhone, FaEnvelope, FaClock } from 'react-icons/fa';
import { FiInstagram, FiYoutube } from 'react-icons/fi';
import { FaFacebookF } from 'react-icons/fa';

const ContactUs = () => {
  return (
    <div className="contact-page">
      <main className="contact-container">
        <div className="contact-content">
          <div className="contact-info animate-fade-in-left">
            <h1 className="contact-title">Get In Touch</h1>
            <p className="contact-subtitle">We'd love to hear from you. Book your appointment or ask us anything.</p>
            
            <div className="contact-details">
              <div className="contact-item">
                <div className="contact-icon">
                  <FaMapMarkerAlt />
                </div>
                <div>
                  <h3>Our Location</h3>
                  <p>Madhurawada, Visakhapatnam,<br />Andhra Pradesh 530041</p>
                </div>
              </div>

              <div className="contact-item">
                <div className="contact-icon">
                  <FaPhone />
                </div>
                <div>
                  <h3>Phone</h3>
                  <p><a href="tel:+919876543210">+91 98765 43210</a></p>
                  <p><a href="tel:+919876543211">+91 98765 43211</a></p>
                </div>
              </div>

              <div className="contact-item">
                <div className="contact-icon">
                  <FaEnvelope />
                </div>
                <div>
                  <h3>Email</h3>
                  <p><a href="mailto:info@celebritycuts.com">info@celebritycuts.com</a></p>
                  <p><a href="mailto:bookings@celebritycuts.com">bookings@celebritycuts.com</a></p>
                </div>
              </div>

              <div className="contact-item">
                <div className="contact-icon">
                  <FaClock />
                </div>
                <div>
                  <h3>Working Hours</h3>
                  <p>Monday - Saturday: 9:00 AM - 8:00 PM</p>
                  <p>Sunday: 10:00 AM - 6:00 PM</p>
                </div>
              </div>
            </div>

            <div className="social-links">
              <h3>Follow Us</h3>
              <div className="social-icons">
                <a href="https://www.instagram.com/celebritycutsinsta/" target="_blank" rel="noopener noreferrer" className="social-icon">
                  <FiInstagram />
                </a>
                <a href="https://www.facebook.com/celebritycuts" target="_blank" rel="noopener noreferrer" className="social-icon">
                  <FaFacebookF />
                </a>
                <a href="https://www.youtube.com/@CelebrityCutsinvizag" target="_blank" rel="noopener noreferrer" className="social-icon">
                  <FiYoutube />
                </a>
              </div>
            </div>
          </div>

          <div className="map-container animate-fade-in-right">
            <h2>Visit Us</h2>
            <div className="map-wrapper">
              <iframe 
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3804.123456789012!2d83.3607242!3d17.8026286!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3a395bd953cc2675%3A0x527e93e27abf7261!2sCelebrity%20Cuts%7C%20best%20salon%20in%20madhurawada%7C%20unisex%20salon%20in%20vizag%7C%20beauty%20salon!5e0!3m2!1sen!2sin!4v1620000000000!5m2!1sen!2sin" 
                width="100%" 
                height="100%" 
                style={{ border: 0 }} 
                allowFullScreen="" 
                loading="lazy"
                title="Celebrity Cuts Location"
              ></iframe>
            </div>
            <div className="map-cta">
              <a 
                href="https://www.google.com/maps/place/Celebrity+Cuts%7C+best+salon+in+madhurawada%7C+unisex+salon+in+vizag%7C+beauty+salon/@17.8026286,83.3607242,17z/data=!3m1!4b1!4m6!3m5!1s0x3a395bd953cc2675:0x527e93e27abf7261!8m2!3d17.8026235!4d83.3632991!16s%2Fg%2F11jzqb0qfv?entry=ttu" 
                target="_blank" 
                rel="noopener noreferrer"
                className="directions-btn"
              >
                Get Directions
              </a>
            </div>
          </div>
        </div>
      </main>
    </div>
  );
};

export default ContactUs;
